import { useEffect } from 'react';
import useGoalInfo from './useGoalInfo';

const useFreshGoalInfo = (
  goalUID,
  options = { selector: null, fallbackData: undefined, swrOptions: undefined }
) => {
  const result = useGoalInfo(goalUID, {
    ...options,
    swrOptions: {
      dedupingInterval: 0,
      ...(options.swrOptions || {})
    }
  });
  const { mutate } = result;

  useEffect(() => {
    if (goalUID) {
      mutate();
    }
  }, [goalUID, mutate]);

  return result;
};

export default useFreshGoalInfo;
